import { AdminRole } from '@pflegia/types/common/enums/admin-role.enum';

export {
  /** @deprecated */
  AdminRole as Role,
};
